
import Alert from 'vux/src/components/alert/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import wx from 'weixin-js-sdk'
import global_ from './global'

export default {
name: 'recharge',
components: {
Group,
Confirm,
Alert,
XButton,
XInput,
CheckIcon,
Checker,
CheckerItem,
Selector,
Card
},
data() {
return {
opid: '',
amount: '',
issue: false,
invoiceType: 1,
invoiceTitle: 2,
invoice: {
content: {
company:'',
taxNumber:'',
bank:'',
bankAccount:'',
address:'',
tel:''
},
type: ''
},
type: 'online',
type_list: [{key: 'online', value: '微信充值'}, {key: 'offline', value: '线下充值'}],
img: '/static/img/bill.png',
bill: '',
invoice_first: false,
invoice_or_bill: 2,
account_type: 'person'
}
},
methods: {
invoice_or_bill_change() {
if (this.invoice_or_bill === 1) {
this.invoice_first = true
this.issue = true
} else {
this.invoice_first = false
this.issue = false
}
},
recharge() {
if (this.amount === '') {
this.$vux.alert.show({
title: '',
content: '请输入充值金额'
})
return
}
console.log(this.invoice)
if (this.issue) {
if (this.invoiceTitle === 2) {
if ((this.invoice.content.company === '') || (this.invoice.content.taxNumber === '')) {
this.$vux.alert.show({
title: '',
content: '请补全发票信息后再提交'
})
return
}
}
if (this.invoiceType === 2) {
if ((this.invoice.content.bank === '') || (this.invoice.content.bankAccount === '') || (this.invoice.content.address === '') || (this.invoice.content.tel === '')) {
this.$vux.alert.show({
title: '',
content: '请补全发票信息后再提交'
})
return
}
}
}
var obj = {
headers: {
token: localStorage.getItem('token'),
opid: this.opid
}
}
var app = this
var data
if (this.type === 'online') {
data = {
body: '云帷充值',
amount: this.amount,
openid: localStorage.getItem('openid'),
issue: this.issue,
invoice: {
content: {
company:'',
taxNumber:'',
bank:'',
bankAccount:'',
address:'',
tel:''
},
type: ''
},
userip: '127.0.0.1'
}
if (this.issue) {
data.invoice.content = this.invoice.content
switch (this.invoiceType) {
case 1:
data.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit'
break;
default:
data.invoice.type = 'VatSpecialInvoice'
break;
}
}
this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=wx_recharge', data, obj)
.then((response) => {
wx.chooseWXPay({
timestamp: response.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: response.data.nonceStr, // 支付签名随机串，不长于 32 位
package: response.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
signType: response.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: response.data.paySign, // 支付签名
success: (res) => {
app.$router.push({name: 'wallet'})
}
})
})
.catch((error) => {
if (error.response) {
if (error.response.data.error_message) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
}
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
} else {
if (this.bill === '') {
this.$vux.alert.show({
title: '',
content: '请上传发票凭据后再提交'
})
return
}
data = {
amount: this.amount,
bill: this.bill,
invoice_first: this.invoice_first,
issue: this.issue,
invoice: {
content: {
company:'',
taxNumber:'',
bank:'',
bankAccount:'',
address:'',
tel:''
},
type: ''
}
}
if (this.invoice_first && !this.issue) {
this.$vux.alert.show({
title: '',
content: '请填写发票信息后再提交'
})
return
}
if (this.issue) {
data.invoice.content = this.invoice.content
switch (this.invoiceType) {
case 1:
data.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit'
break;
default:
data.invoice.type = 'VatSpecialInvoice'
break;
}
}
var obj = {
headers: {
token: localStorage.getItem('token'),
opid: this.opid
}
}
this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=bank_recharge', data, obj)
.then( (response) => {
if (data.invoice_first) {
app.$vux.alert.show({
title: '',
content: '提交成功，请收到发票后尽快汇款，并上传汇款凭据'
})
} else {
app.$vux.alert.show({
title: '',
content: '充值请求提交成功，请等待后台审核'
})
}
app.$router.push({name: 'wallet'})
})
.catch( (error) => {
if (error.response) {
console.log(error.response.data)
if (error.response.data.error_message) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
}
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}
},
upload: function (event) {
var app = this
var obj = {
headers: {
token: localStorage.getItem('token'),
opid: this.opid
}
}
wx.chooseImage({
count: 1, // 默认9
sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: function (res) {
var localIds = res.localIds 
app.img = localIds[0]
if (window.__wxjs_is_wkwebview) {
wx.getLocalImgData({
localId: localIds[0],
success: (res) => {
app.img = res.localData
}
})
}
setTimeout(
wx.uploadImage({
localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
isShowProgressTips: 1, // 默认为1，显示进度提示
success: function (res) {
var serverId = res.serverId 
app.$http.get('/api/v1/payments/' + app.opid + '/orders?type=bill&serverid=' + serverId, obj)
.then(function (response) {
app.bill = response.data[0]
})
.catch(function (error) {
alert('服务器错误，请稍后重试')
if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}
}), 100)
}



})
}
},
mounted() {
this.opid = localStorage.getItem('userid')
setTimeout(() => {
var timestamp = parseInt(new Date().getTime() / 1000)
var url
var u = navigator.userAgent
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
var app = this
this.$http.get('static/config.json').then(response => {
var config = response.data
if (isiOS) {
url = config.host + global_.entryUrl
} else {
url = config.host + app.$route.path
}
var noncestr = Math.random().toString(36).substr(2)
app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url)
.then( (response) => {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: config.appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: noncestr, // 必填，生成签名的随机串
signature: response.data, // 必填，签名
jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi'] 
})
wx.error(function (res) {
alert(res.errMsg)
})
})
.catch(function (error) {
alert('服务器错误，请稍后重试')
if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}, response => {
console.log('数据加载失败')
})
}, 500)
}
}



// WEBPACK FOOTER //
// ./src/components/recharge.vue